import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Header from 'components/Practice/Header'
import Main from 'components/Practice/Main'
import Loading from 'components/Common/Loading'
import Consult from 'components/Common/Consult'
import WritingOverflow from './WritingOverflow'
import { getExerciseId, getAnswer } from 'common/api'
import { getUserInfo } from 'common/user'
import config from 'config'
import isBoolean from 'lodash/isBoolean'
import isInteger from 'lodash/isInteger'
import { SmartSignPop } from 'smart-login-new'

import Correction from 'components/Common/Correction'

import 'smart-login-new/dist/smartlogin.css'

@observer(['practiceStore'])
export default class Practice extends Component {
  constructor (props) {
    super(props)

    this.timer = null
  }

  componentWillReceiveProps (nextProps) {
    const { practiceStore } = this.props
    const { pid, qid } = nextProps.params

    if (qid !== this.props.params.qid) {
      practiceStore.toggleLoading(true)
      this.initializeUserAnswer(qid, nextProps.location.query)
          .then(() => this.initializeOther())
          .then(() => this.loadData(pid, qid))
          .then(() => {
            window.MathJax.Hub.Typeset()
            practiceStore.toggleLoading(false)
          })
          .catch(err => {
            if (err.message === 'BAD_TOKEN') {
              practiceStore.toggleLogin(true)
              practiceStore.toggleLoading(false)
            } else {
              throw err
            }
          })
    }
  }

  componentDidMount () {
    const { practiceStore, location } = this.props
    const { pid, qid } = this.props.params

    // 设置背景为白色
    document.body.style.backgroundColor = 'white'
    document.documentElement.style.backgroundColor = 'white'

    practiceStore.toggleLoading(true)
    let info = {
      eventType: 'enterExercise',
      detailedInfo: {
        practiceId: pid,
        questionId: qid,
        exerciseId: sessionStorage.getItem('EXERCISE') || ''
      },
      userId: getUserInfo() ? getUserInfo().id : ''
    }
    let isChrome = navigator.appVersion.indexOf('Chrome') > -1;
    window.ssAccess && window.ssAccess.log(info)
    this.initializeExercise()
        .then(() => this.initializeUserAnswer(qid, location.query))
        .then(() => this.initializeOther())
        .then(() => this.loadData(pid, qid))
        .then(() => {
          this.startTimer()
          window.MathJax.Hub.Typeset()
          practiceStore.toggleLoading(false)
          if (!isChrome && practiceStore.category === 'speaking'){
            practiceStore.toggleWritingOverflow(true, 'BrowserNotFit')
          }
        })
        .catch(err => {
          if (err.message === 'BAD_TOKEN') {
            practiceStore.toggleLogin(true)
            practiceStore.toggleLoading(false)
          } else {
            throw err
          }
        })
  }

  componentWillUnmount () {
    if (this.timer) { window.clearInterval(this.timer) }
  }

  loadData (pid, qid) {
    const { practiceStore } = this.props

    practiceStore.resetState()
    practiceStore.loadSessionData(qid)
    return practiceStore.fetchData(pid, qid)
  }

  initializeExercise () {
    const { location } = this.props
    const { pid, qid } = this.props.params
    sessionStorage.clear()

    if (location.query.exerciseId) {
      sessionStorage.setItem('EXERCISE', location.query.exerciseId)
      return Promise.resolve()
    }

    if (sessionStorage.getItem('EXERCISE')) { return Promise.resolve() }

    return getExerciseId(pid, qid, location.query)
      .then(id => {
        sessionStorage.setItem('EXERCISE', id)
      })
  }

  initializeUserAnswer (qid, query) {
    const userInfo = getUserInfo()
    const EXERCISE = sessionStorage.getItem('EXERCISE')
    const COST_TIME = JSON.parse(sessionStorage.getItem('COST_TIME'))
    const ALL_ANSWERS = JSON.parse(sessionStorage.getItem('ALL_ANSWERS')) || {}

    if (ALL_ANSWERS[qid]) { return Promise.resolve() }

    if (!query.uid && !userInfo) {
      ALL_ANSWERS[qid] = []
      sessionStorage.setItem('ALL_ANSWERS', JSON.stringify(ALL_ANSWERS))

      if (!isInteger(COST_TIME)) {
        sessionStorage.setItem('COST_TIME', 0)
      }
      // 取答案是如果 没登录就提示登录
      const { practiceStore } = this.props
      practiceStore.toggleLogin(true)

      return Promise.resolve()
    }

    return getAnswer(qid, EXERCISE, userInfo ? userInfo.token : null, query)
      .then(data => {
        ALL_ANSWERS[qid] = data.answer
        sessionStorage.setItem('ALL_ANSWERS', JSON.stringify(ALL_ANSWERS))
        if (!isInteger(COST_TIME)) {
          sessionStorage.setItem('COST_TIME', data.timeCost || 0)
        }
      })
  }

  initializeOther () {
    const SHOW_TIMER = JSON.parse(sessionStorage.getItem('SHOW_TIMER'))

    if (!isBoolean(SHOW_TIMER)) {
      sessionStorage.setItem('SHOW_TIMER', true)
    }

    return Promise.resolve()
  }

  startTimer () {
    const { practiceStore } = this.props

    if (this.timer) { window.clearInterval(this.timer) }

    this.timer = window.setInterval(() => {
      practiceStore.timePass()
    }, 1000)
  }

  render () {
    const { practiceStore } = this.props
    return (
      <div>
        { practiceStore.show.loading ? <Loading /> : null }
        <Consult show={ practiceStore.show.askTeacher } onClose={ () => practiceStore.toggleAskTeacher(false) } />
        {
          practiceStore.show.correction ?
          <Correction
            questionId={ practiceStore.id }
            questionName={ practiceStore.name }
            onClose={ () => practiceStore.showCorrection(false) }
          /> :
          null
        }
        { practiceStore.show.writingOverflow ? <WritingOverflow onClose={ () => practiceStore.toggleWritingOverflow(
        ) } errorType={practiceStore.show.writingErrorType}/> : null }
        <SmartSignPop
          popType={ practiceStore.show.login ? 1 : 0 }
          from={ config.userCenter.from }
          group={ config.userCenter.group }
          smartUrl={ config.site.zhike }
          source={ config.userCenter.source }
          userCenterApi={ config.userService.url }
          card={ config.cardService.url }
          closePop={ () => practiceStore.toggleLogin(false) } />
        <Header />
        <Main
          exam={this.props.params.exam === 'tamg' ? 'gmat' : this.props.params.exam}/>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/Practice/index.js
 **/